import { MessageCodes } from '../Components/Output/MessageCodes';
import { PlanProfiles } from '../Components/ProjectUploader';
import JSZip from "jszip";
import ShapeFileHelper from "./ShapeFileHelper";

const tsv = require('tsv');
const getProjectTitle = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Proj Title')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '');
        }
    }
};

const getProjectDescription = (text) => {
    const split = text.split('\n');
    const descriptions = [];
    let isFind = false;
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('BEGIN DESCRIPTION')) {
            isFind = true;
            continue;
        }

        if (line.includes('END DESCRIPTION')) break;

        if (isFind) descriptions.push(line);
    }

    return descriptions;
};

const getGeometryTitle = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Geom Title')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '');
        }
    }
};

const getGeometryFile = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Geom File')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '');
        }
    }
};

const getFlowFile = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Flow File')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '');
        }
    }
};

const getPlanTitle = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Plan Title')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '');
        }
    }
};

const getPlanShortIdentifier = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Short Identifier')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '')
                .trim();
        }
    }
};

const getPlanVersion = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Program Version') || line.includes('Version')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '')
                .trim();
        }
    }
};

const getPlanDescription = (text) => {
    const split = text.split('\n');
    const descriptions = [];
    let isFind = false;
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('BEGIN DESCRIPTION')) {
            isFind = true;
            continue;
        }

        if (line.includes('END DESCRIPTION')) break;

        if (isFind) descriptions.push(line);
    }

    return descriptions;
};

const getFlowTitle = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Flow Title')) {
            return line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '');
        }
    }
};

const getFlowProfiles = (text) => {
    const split = text.split('\n');
    for (let i = 0; i < split.length; i++) {
        const line = split[i];
        if (line.includes('Profile Names')) {
            const profiles = line
                .split('=')[1]
                .replaceAll('\\r', '')
                .replaceAll('\\n', '');
            return profiles.split(',').map((x) => x.trim());
        }
    }
    return [];
};

const checkColumns = (text) => {
    if (!text) return [];

    const columns = text
        .split('\n')[0]
        .split('\t')
        .map((x) => x.trim());
    let def = [
        'Prof Delta WS',
        'Conv. Ratio',
        'Sta W.S. Lft',
        'Sta W.S. Rgt',
        'Vel Head',
        'Headloss',
        'W.S. Elev',
        'Crit W.S.',
        'Mann Wtd Chnl',
        'Mann Wtd Rght',
        'Mann Wtd Left',
    ];
    let filtered = def.filter((x) => !columns.includes(x));

    return filtered;
};

const getRiverReachColumns = (text) => {
    if (!text) return [];

    const columns = text
        .split('\n')[0]
        .split('\t')
        .map((x) => x.trim());
    let def = ['River', 'Reach'];
    let filtered = def.filter((x) => !columns.includes(x));

    return filtered;
};

const parseAllOutputProfiles = (text) => {
    const data = tsv.parse(text);
    const filteredData = [];

    //filter empty data and culvert
    data.forEach((x, index) => {
        if (index === 0) return;

        const keys = Object.keys(x);
        let empty = 0;
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (x[key] === 'Culvert') {
                continue;
            }

            if (!x[key] || x[key] === '') empty++;
        }

        if (empty <= keys.length / 2) {
            filteredData.push(x);
        }
    });

    const plans = [];

    filteredData.forEach((row) => {
        let plan = plans.find((x) => x.Plan === row.Plan);
        if (!plan) {
            plan = {
                Plan: row.Plan,
                profiles: [],
            };
            plans.push(plan);
        }

        if (plan) {
            plan.profiles.push({
                Profile: row.Profile,
                data: {
                    Plan: row.Plan,
                    Reach: row.Reach,
                    River: row.River,
                    CrossSection: row['River Sta']?.toString(),
                    Profile: row['Profile'],
                    WSElev: parseFloat(row['W.S. Elev']),
                    ProfDeltaWS: parseFloat(row['Prof Delta WS']),
                    StaWSLft: parseFloat(row['Sta W.S. Lft']),
                    StaWSRgt: parseFloat(row['Sta W.S. Rgt']),
                    VelHead: parseFloat(row['Vel Head']),
                    ConvRatio: parseFloat(row['Conv. Ratio']),
                    Headloss: parseFloat(row['Headloss']),
                    MannWtdChnl: parseFloat(row['Mann Wtd Chnl']),
                    MannWtdLeft: parseFloat(row['Mann Wtd Left']),
                    MannWtdRight: parseFloat(row['Mann Wtd Rght']),
                    CritWS: parseFloat(row['Crit W.S.']),
                },
            });
        }
    });

    return plans;
};

const hasGeoReferenced = (geoFile) => {
    if (!geoFile) return false;

    const lines = geoFile.split('\n');

    let reach_xy = [];
    const hasXsGIS =
        lines.filter((x) => x?.startsWith('XS GIS Cut'))?.length > 0;

    let is_start = false;
    for (const line of lines) {
        if (line.startsWith('Reach XY=')) {
            is_start = true;
            continue;
        }

        if (is_start) {
            reach_xy = [
                ...reach_xy,
                ...line
                    .split(' ')
                    .filter((x) => x.trim())
                    .map((y) => parseFloat(y)),
            ];
        }

        if (reach_xy.length >= 50) break;
    }

    return (
        !(reach_xy.filter((x) => x < 1).length >= reach_xy.length / 2) &&
        hasXsGIS
    );
};

const mapProfiles = (plan, mapData) => {
    if (!plan) return;

    const outputs = [];

    plan.profiles?.forEach((row) => {
        const emptyItem = {
            Plan: plan.Plan,
            Reach: row.data.Reach,
            River: row.data.River,
            CrossSection: row.data.CrossSection,
            Profile: null,
            WSElev: null,
            CritWS: null,
            ProfDeltaWS: null,
            StaWSLft: null,
            StaWSRgt: null,
            VelHead: null,
            ConvRatio: null,
            Headloss: null,
            MannWtdChnl: null,
            MannWtdLeft: null,
            MannWtdRight: null,
        };

        let item = outputs.find(
            (x) =>
                x.CrossSection === row.data.CrossSection &&
                x.River === row.data.River &&
                x.Reach === row.data.Reach
        );
        if (!item) {
            item = {
                Reach: row.data.Reach,
                River: row.data.River,
                CrossSection: row.data.CrossSection,
                FW: emptyItem,
                YR2: emptyItem,
                YR10: emptyItem,
                YR25: emptyItem,
                YR50: emptyItem,
                YR100: emptyItem,
                YR500: emptyItem,
                FUT10: emptyItem,
                FUT20: emptyItem,
                FUT35: emptyItem,
                FUTULT: emptyItem,
            };
            outputs.push(item);
        }

        const map = mapData.find(
            (x) => {
                const regx = /^\d+(\.\d+)?$/
                if(regx.test(x?.select?.toString()) && regx.test(row?.Profile?.toString())) {
                    if(parseFloat(x?.select) === parseFloat(row?.Profile)) {
                        return true
                    }
                }

                return x?.select?.toString() === row?.Profile?.toString()
            }
        );

        if (map && map.target) {
            item[map.target] = {
                ...row.data,
                Profile: map.target,
            };
        }
    });

    return outputs;
};

const findMinMax = (data, type) => {
    const copy_data = data.map((x) => {
        let text = x?.toString();
        if (text?.includes('/')) text = text?.split('/')[0]?.trim();
        if (text?.includes('(')) text = text?.split('(')[0]?.trim();

        return { value: parseFloat(text), text: x };
    });

    const min =
        type === 'min'
            ? Math.min(...copy_data.map((x) => x.value))
            : Math.max(...copy_data.map((x) => x.value));
    const val = copy_data.find((x) => x.value === min);

    if (val?.text?.toString().includes('BR U')) {
        const findStr = val.text.replaceAll('BR U', 'BR D');
        let br_d = copy_data.find((x) => x.text === findStr);
        if (br_d) return br_d;
    }

    return val?.text ?? -1;
};

const getCSList = (operations) => {
    const cs = [];
    for (const operation of operations) {
        for (const child of operation.children) {
            const result = child.result?.result;
            if (result) {
                for (const res of result) {
                    for (const row of res.data) {
                        cs.push(row.cross_section.toString());
                    }
                }
            }
        }
    }

    cs.sort(function (a, b) {
        return parseFloat(b) - parseFloat(a);
    });

    return Array.from(new Set([...cs])).map((x) => ({
        name: x,
        value: parseFloat(x),
    }));
};

const getStructureList = (geoFile, river, reach) => {
    const lines = geoFile?.split('\n');
    const csList = [];

    let isRiverStart = false;
    lines?.forEach((line, idx) => {
        if (line?.startsWith('River Reach=')) {
            if (
                river &&
                reach &&
                line?.includes(river) &&
                line?.includes(reach)
            ) {
                isRiverStart = true;
            } else if (!river && !reach) {
                isRiverStart = true;
            }
        }

        if (isRiverStart && line?.startsWith('River Reach=')) {
            if (
                river &&
                reach &&
                (!line?.includes(river) || !line?.includes(reach))
            ) {
                isRiverStart = false;
            }
        }

        if (isRiverStart) {
            if (line?.includes('Type RM Length L Ch R =')) {
                const props = line
                    .split('=')[1]
                    ?.split(',')
                    .map((x) => x.trim());
                if (parseFloat(props[0]) > 1) {
                    csList.push({
                        name: props[1],
                        value: parseFloat(props[1]),
                        type: props[0],
                    });
                }
            }
        }
    });

    return csList;
};

const inFilter = ({ us, ds, cs_name }) => {
    if (!us && !ds) {
        return false;
    }

    let res = true;
    if (ds && parseFloat(cs_name) < parseFloat(ds)) {
        res = false;
    }
    if (us && parseFloat(cs_name) > parseFloat(us)) res = false;

    return res;
};

const filterResult = ({ operations, filter }) => {
    for (const operation of operations || []) {
        for (const child of operation?.children || []) {
            for (const result of child?.data?.result || []) {
                if (!result.originalData)
                    result.originalData = [...(result?.data || [])];

                if (!filter.us && !filter.ds)
                    result.data = [...result.originalData];
                else if (filter.type === 'filter') {
                    result.data = result.originalData.filter((x) =>
                        inFilter({
                            us: filter.us,
                            ds: filter.ds,
                            cs_name: x.cross_section,
                        })
                    );
                } else if (
                    filter.type === 'highlight' ||
                    filter.filterType === 'clear'
                ) {
                    result.data = [...result.originalData];
                }
            }
        }
    }

    return operations;
};

const sortOperationsResults = ({ operations, direction }) => {
    for (const operation of operations || []) {
        for (const child of operation?.children || []) {
            for (const result of child?.data?.result || []) {
                if (direction === 'ds')
                    result.data = result?.data?.sort((a, b) => {
                        if (a.cross_section || b.cross_section) {
                            return parseFloat(a.cross_section) >
                                parseFloat(b.cross_section)
                                ? -1
                                : 1;
                        }
                    });
                else if (direction === 'us')
                    result.data = result?.data?.sort((a, b) => {
                        if (a.cross_section || b.cross_section) {
                            return parseFloat(a.cross_section) >
                                parseFloat(b.cross_section)
                                ? 1
                                : -1;
                        }
                    });
            }
        }
    }

    return operations;
};

const sortResults = ({ results, direction }) => {
    for (const _result of results || []) {
        if (direction === 'ds')
            _result.data = _result?.data?.sort((a, b) => {
                if (a.cross_section || b.cross_section) {
                    return parseFloat(a.cross_section) >
                        parseFloat(b.cross_section)
                        ? -1
                        : 1;
                }
            });
        else if (direction === 'us')
            _result.data = _result?.data?.sort((a, b) => {
                if (a.cross_section || b.cross_section) {
                    return parseFloat(a.cross_section) >
                        parseFloat(b.cross_section)
                        ? 1
                        : -1;
                }
            });
    }
};

const extractCSTextLines = (geoFile, csName) => {
    const lines = geoFile?.split('\n');
    let textLines = []
    let isFound = false
    for (const line of lines) {
        if(line.startsWith('Type RM Length') && line.includes(csName)) {
            isFound = true
            textLines.push(line);
        }
        else if(line.startsWith('Type RM Length') && isFound) {
            isFound = false
        }
        else if(isFound) {
            textLines.push(line);
        }
    }

    return textLines
}

const getCSListWithBridge = ({ geoFile, includeIB, includeStructure }) => {
    const lines = geoFile
        ?.split('\n')
        ?.filter((x) => x.includes('Type RM Length'));

    const cs_list = [];
    for (const line of (lines || [])) {
        if (line) {
            const split = line.split('=');
            if (split.length > 1) {
                const props = split[1]?.split(',')?.map((x) => x?.trim());

                if (props.length >= 2) {
                    if(parseInt(props[0]) === 1) {
                        cs_list.push({
                            name: props[1],
                            value: parseFloat(props[1]),
                            type: 'CrossSection'
                        });
                    }
                    else if (parseInt(props[0]) === 3) {
                        if(includeIB) {
                            cs_list.push({
                                name: `${props[1]} BR U`,
                                value: parseFloat(props[1]),
                                type: 'IB',
                            });    
                        }
                        if(includeStructure) {
                            cs_list.push({
                                name: props[1],
                                value: parseFloat(props[1]),
                                type: 'Bridge',
                            });
                        }
                        if (includeIB) {
                            cs_list.push({
                                name: `${props[1]} BR D`,
                                value: parseFloat(props[1]),
                                type: 'IB',
                            });
                        }
                    }
                    else if(parseInt(props[0]) === 4) {
                        const moLines = extractCSTextLines(geoFile, props[1])
                        const multiples = moLines.filter(x => x.startsWith('BC Mult='))
                        let number = 1;
                        for (const mo of multiples) {
                            const moSplit = mo.split('=');
                            const moProps = moSplit[1]?.split(',')?.map((x) => x?.trim());

                            if(parseInt(moProps[0]) === 3) {
                                if(includeIB) {
                                    cs_list.push({
                                        name: `${props[1]} BR U #${number}`,
                                        value: parseFloat(props[1]),
                                        type: 'MultipleOpening',
                                    });
                                }
                                if (includeIB) {
                                    cs_list.push({
                                        name: `${props[1]} BR D #${number}`,
                                        value: parseFloat(props[1]),
                                        type: 'MultipleOpening',
                                    });
                                }

                                number++;
                            }
                        }
                    }
                }
            }
        }
    }
    return cs_list;
};

const calcWSEL = ({
    C11,
    C1,
    C2,
    C3,
    C4,
    C5,
    C6,
    C7,
    C12,
    C13,
    C15,
    C20,
    C21,
    minCS,
    maxCS,
    csList,
}) => {
    let section_list = [C1, C2, C3, C4, C5, C6, C7, C12, C13, C15, C20, C21];

    const cross_sections = [];
    let min_section = -1;
    let max_section = -1;

    section_list.forEach((x) => {
        x?.data?.result?.forEach((y) => {
            y?.data?.forEach((z) => {
                if (Object.keys(z)?.includes('cross_section')) {
                    cross_sections.push({
                        name: z['cross_section'],
                        title: x.title,
                    });
                }
            });
        });
    });

    min_section = findMinMax(
        cross_sections.map((x) => x.name),
        'min'
    );
    max_section = findMinMax(
        cross_sections.map((x) => x.name),
        'max'
    );

    let wsel_sections = [];

    C11?.data?.result?.forEach((x) => {
        if (x?.error_id === MessageCodes.Compare.TWSEL000.error_id) return;

        x?.data?.forEach((y, idx) => {
            if (idx === 0 && parseFloat(y['diff']) === 0) {
                return;
            }

            if (idx === x?.data?.length - 1 && parseFloat(y['diff']) === 0) {
                return;
            }

            if (Object.keys(y)?.includes('cross_section')) {
                wsel_sections.push(y['cross_section']);
            }
        });
    });

    if (wsel_sections.length > 0 && wsel_sections[0] === 0)
        wsel_sections = wsel_sections.splice(0, 1);

    if (
        wsel_sections.length > 0 &&
        wsel_sections[wsel_sections.length - 1] === 0
    )
        wsel_sections = wsel_sections.splice(wsel_sections.length - 1, 1);

    const wsel_min = findMinMax(wsel_sections, 'min');
    const wsel_max = findMinMax(wsel_sections, 'max');

    const project_min = findMinMax(
        [wsel_min, min_section].filter((x) => x && x !== -1),
        'min'
    );
    const project_max = findMinMax(
        [wsel_max, max_section].filter((x) => x && x !== -1),
        'max'
    );

    const bound_min = csList
        .filter(
            (x) => !x.value.toString().includes('BR') && x.value < project_min
        )
        .map((x) => x.value);
    const bound_max = csList
        .filter(
            (x) => !x.value.toString().includes('BR') && x.value > project_max
        )
        .map((x) => x.value);

    const boundary_min =
        bound_min.length > 0 ? Math.max(...bound_min) : project_min;
    let boundary_max =
        bound_max.length > 0 ? Math.min(...bound_max) : project_max;

    if (wsel_max !== -1)
        cross_sections.push({ name: wsel_max, title: '100yr WSEL' });
    if (wsel_min !== -1)
        cross_sections.push({ name: wsel_min, title: '100yr WSEL' });

    return {
        affected_reach_min: wsel_min,
        affected_reach_max: wsel_max,
        revised_reach_min: min_section,
        revised_reach_max: max_section,
        project_min: project_min,
        project_max: project_max,
        boundary_min,
        boundary_max,
        topics: cross_sections,
        minCS,
        maxCS,
    };
};

const isUndefined = (val, noneText) => {
    if (val === 0) return val;

    if (!val) return noneText || '-';

    return val;
};

const getUSDS = ({ us, ds, csList }) => {
    let us_val = null;
    let ds_val = null;

    if (us) {
        us_val = csList.find((x) => parseFloat(x.name) === parseFloat(us));
        if (!us_val) {
            const filtered = csList
                .filter((x) => x.name <= parseFloat(us))
                .sort((a, b) => a - b);
            us_val = filtered[0];
        }
    }

    if (ds) {
        ds_val = csList.find((x) => parseFloat(x.name) === parseFloat(ds));
        if (!ds_val) {
            const filtered = csList
                .filter((x) => parseFloat(x.name) >= parseFloat(ds))
                .sort((a, b) => a - b);
            ds_val = filtered[0];
        }
    }

    return { us_val, ds_val };
};

const getWidth = (width) => {
    return (width * 100) / 12.5;
};

const checkProjectFiles = (project) => {
    const output = project?.files?.find((x) => x.type === 'output');
    project?.projectFiles?.forEach((plan) => {
        plan.hasGeoReferenced = hasGeoReferenced(plan?.geometry?.text);
        plan.mapProfiles?.forEach((x) => {
            x.targetName = PlanProfiles.find(
                (y) => y.value === x.target
            )?.label;
        });

        const findOutput = output?.data?.find(
            (x) =>
                x?.Plan?.trim() === plan?.plan?.title?.trim() ||
                x.Plan === plan?.plan?.shortIdentifier?.trim()
        );
        if (project?.projectFiles?.length > 1 && !findOutput) {
            plan.isFindOutput = 'false';
            plan.mappedProfiles = [];
        }
    });

    for (const shape of (project?.shapeFiles || [])) {
        if(shape?.ext?.toLowerCase() !== 'geojson') {
            continue
        }

        const attributes = ShapeFileHelper.getAttributesData(shape?.data)
        const keys = []

        let index = 0;
        for (const attr of attributes) {
            keys.push(...Object.keys(attr))
            index++
            if(index === 10)
                break
        }

        shape.hasSurveyData = keys.includes('SURVSTR_ID') || keys.includes('SURV_CODE') || keys.includes('SURVPT_ID');
    }

    return {
        ...project,
        information: {
            ...(project?.information || {}),
            outputColumns: HecRasHelper.checkColumns(output?.text),
            riverReachColumns: HecRasHelper.getRiverReachColumns(output?.text),
            hasOutputFile: output ? 'true' : 'false',
        },
    };
};

const isLibraryPlan = (plan) => {
    if (!plan) return false;

    let count = 0;
    for (let i = 0; i < plan.mapProfiles.length; i++) {
        const profile = plan.mapProfiles[i];
        const next_profile = plan.mapProfiles[i + 1];

        if (
            parseFloat(next_profile?.select) - parseFloat(profile?.select) ===
            0.5
        ) {
            count++;
        }
    }

    return count > 3;
};

const compressProject = async (project) => {
    const zip = new JSZip()
    for (const file of project.projectFiles) {
        zip.file(file.plan.fileName, file.plan.text)
        zip.file(file.flow.fileName, file.flow.text)
        zip.file(file.geometry.fileName, file.geometry.text)
        if(file.outputBinFile) {
            zip.file(file.outputBinFile.fileName, file.outputBinFile.text, {base64: true})
        }
    }

    zip.file(project.information.fileName, project.information.text)



    const zipFile = await zip.generateAsync({type: "blob", compression: "DEFLATE"})

    return zipFile
}

const HecRasHelper = {
    getProjectTitle,
    getProjectDescription,
    getFlowTitle,
    getFlowProfiles,
    getGeometryTitle,
    getPlanTitle,
    getGeometryFile,
    getFlowFile,
    parseAllOutputProfiles,
    mapProfiles,
    getPlanShortIdentifier,
    getPlanVersion,
    checkColumns,
    getRiverReachColumns,
    calcWSEL,
    isUndefined,
    getCSList,
    filterResult,
    sortOperationsResults,
    sortResults,
    inFilter,
    getUSDS,
    getWidth,
    checkProjectFiles,
    hasGeoReferenced,
    isLibraryPlan,
    getStructureList,
    getCSListWithBridge,
    compressProject
};

export default HecRasHelper;
